module.exports = __webpack_public_path__ + "img/centro.39dfa449.jpg";